import React, { useEffect } from 'react';
import { InvoiceForm } from '../../../Components/Form';
import { FormLayout } from '../../../Components';
import { NewInvoiceIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const Temporaryedit = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Invoice.menu.temporary_edit');
  }, []);

  return (
    <FormLayout
      title={t('Invoice.title')}
      Icon={NewInvoiceIcon}
      subtitle={t('Invoice.menu.temporary_edit')}
      closeUrl="/invoices"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <InvoiceForm
        title={t('Invoice.invoice_form.edit_invoice')}
        type="edit"
        isTemporaryEdit={true}
        idFromHeaderWrapper={props.idFromHeaderWrapper}
        handleToast={props.handleToast}
      />
    </FormLayout>
  );
};

export default Temporaryedit;
